/** @format */

import clsx from 'clsx';
import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import theme from 'theme';

import {useSensorBarListStyles} from './styles';

export type SensorBarColorScheme = 'neutral' | 'yellow' | 'red';

type Props = {
  name: string;
  description: string;
  totalFound: number;
  totalNew?: number;
  title: string;
  icon: string;
  colorScheme?: SensorBarColorScheme;
  onClickRow: (sensorName: string) => void;
};

const SensorBarList = (props: Props) => {
  const {
    name = '',
    description,
    totalNew,
    totalFound,
    title,
    icon,
    colorScheme = 'neutral',
    onClickRow,
  } = props;

  const classes = useSensorBarListStyles();
  const {t} = useTranslation();

  return (
    <Box
      className={clsx(
        classes.row,
        colorScheme === 'yellow' && classes.yellowBorder,
        colorScheme === 'red' && classes.redBorder,
      )}
      mb={4}
      onClick={() => onClickRow(name)}
      data-testid={`sensor-bar-${name}`}
    >
      <Box className={classes.content}>
        <Box
          display='flex'
          flexDirection='column'
          justifyContent='flex-start'
          className={classes.textContainer}
        >
          <Box
            sx={{
              display: 'flex',
              gap: theme.spacing(1),
            }}
          >
            <Box className={classes.compactIcon}>
              <img alt='category icon' src={icon} width='11' height='11' />
            </Box>
            <Typography className={classes.title}>{title}</Typography>
          </Box>
          <Typography className={classes.description}>{description}</Typography>
        </Box>
      </Box>

      <Box
        alignItems='center'
        display='flex'
        flexDirection='column'
        justifyContent='space-between'
        className={classes.recommendationsWrapper}
      >
        <Box
          className={clsx(
            classes.recommendationsContainer,
            colorScheme === 'yellow' && classes.yellowBorder,
            colorScheme === 'red' && classes.redBorder,
          )}
        >
          <Typography
            className={clsx(
              classes.recommendationsText,
              colorScheme === 'yellow' && classes.yellowText,
              colorScheme === 'red' && classes.redText,
            )}
          >
            {totalFound}
          </Typography>
          {Boolean(totalNew && totalNew > 0) && (
            <Typography
              className={clsx(
                classes.recommendationsText,
                colorScheme === 'yellow' && classes.yellowText,
                colorScheme === 'red' && classes.redText,
              )}
            >
              &nbsp;({t('plurals.new_warnings', {count: totalNew})})
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default SensorBarList;
